import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.offWhite,
  bgColorDark: colors.charcoalGrey,
  textColorDark: colors.charcoalGrey,
  textColorLight: colors.white
};
export default fiftyFiftyCard;